import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=278c1a18&scoped=true&"
import script from "./payment.vue?vue&type=script&lang=js&"
export * from "./payment.vue?vue&type=script&lang=js&"
import style0 from "./payment.vue?vue&type=style&index=0&id=278c1a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278c1a18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('278c1a18')) {
      api.createRecord('278c1a18', component.options)
    } else {
      api.reload('278c1a18', component.options)
    }
    module.hot.accept("./payment.vue?vue&type=template&id=278c1a18&scoped=true&", function () {
      api.rerender('278c1a18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/payment.vue"
export default component.exports